import {
  AlignLeft,
  AlignJustify,
  AtSign,
  Phone,
  Link2,
  Hash,
  Calendar,
  ChevronDown,
  CheckSquare,
  List,
  BarChart2,
  Paperclip,
  Mail,
  ListPlus,
  CreditCard,
  Info,
} from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { ApplicationFieldType } from '@/types'

interface FieldTypeOption {
  type: ApplicationFieldType
  label: string
  description: string
  icon: React.ElementType
}

const FIELD_TYPES: FieldTypeOption[] = [
  { type: 'short_text', label: 'Short Text', description: 'Single-line text input', icon: AlignLeft },
  { type: 'long_text', label: 'Long Text', description: 'Multi-line text area', icon: AlignJustify },
  { type: 'email', label: 'Email', description: 'Email address input', icon: AtSign },
  { type: 'phone', label: 'Phone', description: 'Phone number input', icon: Phone },
  { type: 'url', label: 'URL / Link', description: 'Website URL input', icon: Link2 },
  { type: 'number', label: 'Number', description: 'Numeric input', icon: Hash },
  { type: 'date', label: 'Date', description: 'Date picker', icon: Calendar },
  { type: 'dropdown', label: 'Dropdown', description: 'Single selection from list', icon: ChevronDown },
  { type: 'multiple_choice', label: 'Multiple Choice', description: 'Radio button selection', icon: List },
  { type: 'checkbox_group', label: 'Checkbox Group', description: 'Multiple selections allowed', icon: CheckSquare },
  { type: 'linear_scale', label: 'Linear Scale', description: 'Numeric rating scale', icon: BarChart2 },
  { type: 'file_upload', label: 'File Upload', description: 'File attachment', icon: Paperclip },
  { type: 'mailing_list', label: 'Mailing List Opt-In', description: 'Newsletter subscription checkbox', icon: Mail },
  { type: 'text_list', label: 'Text List', description: 'Multiple text entries with optional cap', icon: ListPlus },
  { type: 'payment', label: 'Payment', description: 'Charge the applicant a fee on submission', icon: CreditCard },
  { type: 'notice', label: 'Notice / Disclaimer', description: 'Read-only markdown text shown in the form', icon: Info },
]

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSelect: (type: ApplicationFieldType) => void
}

export function FieldTypePicker({ open, onOpenChange, onSelect }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Add Field</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {FIELD_TYPES.map(({ type, label, description, icon: Icon }) => (
            <button
              key={type}
              type="button"
              onClick={() => {
                onSelect(type)
                onOpenChange(false)
              }}
              className="flex flex-col items-start gap-2 rounded-lg border p-3 text-left transition-colors hover:bg-accent hover:text-accent-foreground"
            >
              <Icon className="h-5 w-5 text-muted-foreground" />
              <div>
                <p className="text-sm font-medium leading-none">{label}</p>
                <p className="mt-1 text-xs text-muted-foreground">{description}</p>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { FIELD_TYPES }
